jQuery(function($) {
	var googleMaps = $('[data-google-map]')
	var localAreaFilter = $('#categories_filter')
	var localAreaCategory = $('.local_area_card_category')
	var localAreaCards = $('.local_area_card')
	var categoryFilter, activeCategory

	if($('#categories_filter').length)
		var categoryFilter = new detailSelect('#categories_filter')


	// create object for google map markers from local area cards template
	var markers = localAreaCards.map(function () {
		var markerID = $(this).data("id");
		var markerLat = $(this).data("latitude")
		var markerLong = $(this).data("longitude")
		var markerCategory = $(this).data("category")
		var markerTitle = $(this).data("title")

	 	return {"id": markerID, "lat": markerLat, "long": markerLong, "category": markerCategory, "title": markerTitle};
	});

	// watch for category filter changes and trigger filtering of local area cards & map markers
	localAreaFilter.change(function() {
		activeCategory = $(this).find(':checked').val();

		if(!activeCategory)
			activeCategory = undefined

		filterLocalAreaCards(activeCategory);
		googleMap.filterPins(activeCategory);
	});

	// filter categories if local area card category clicked
	localAreaCategory.on("click", function(e){
		e.preventDefault()
		activeCategory = $(this).data('category')

		localAreaFilter.find('[value='+ activeCategory +']').trigger('click');

		$([document.documentElement, document.body]).animate({
			scrollTop: localAreaFilter.offset().top-160
		}, 1000)
	})

	//function that filters local area cards when category selection changes
	function filterLocalAreaCards(category){
		localAreaCards.addClass("hidden");​

		if(category)
			localAreaCards.filter('[data-category=' + category + ']').removeClass("hidden");​
		else
			localAreaCards.removeClass("hidden");​

		googleMap.positionCards()
	}

	//variable to contain all GMap functionality
	var GoogleMap = function(selector, markers) {

		this.initGoogleMap = function() {
			var map, marker, prevActiveCard, currActiveCard
			var scrollAnimating = false
			var latlng = new google.maps.LatLng(21.274639, -157.823242)
			var cards = []
			var allMarkers = []
			var mapDiv = $(selector)
			var address = mapDiv.data('address')
			var zoom = mapDiv.data('zoom')
			var pin = "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_inactive.svg";
			var ALO_pin = "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_ALO.svg";
			var mapOptions = {
				'zoom': zoom/1.1,
				'center': latlng,
				'disableDefaultUI': false,
				'scrollwheel': false,
				'streetViewControl': false,
				'mapTypeControl': false,
				'fullscreenControl': false,
				'draggable' : false,
				'zoomControlOptions': {
					'position': google.maps.ControlPosition.LEFT_BOTTOM
				},
				'icon': ALO_pin
			}

			if (!window.is_mobile){
				mapOptions['draggable'] = true
				mapOptions['zoom'] = zoom
			}

			//create google map object
			map = new google.maps.Map(mapDiv[0], mapOptions)

			//create main map marker & click listener
			markerALO = new google.maps.Marker({
				'position': new google.maps.LatLng(21.274639, -157.823242),
				'map': map,
				'opacity': 1,
				'icon': ALO_pin,
				'id' : 0,
				'title': 'Alohilani Resort Waikiki Beach',
				'zIndex': 1
			});

			markerALO.addListener("click", function (event) {
				if(event && !window.is_mobile){
					scrollToCard(this.id)
				}

				if(!event && window.is_mobile){
					resetMarkers(allMarkers)
					map.panTo(this.position)
					this.setOptions({'opacity': 1, 'icon': "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_ALO.svg", 'zIndex': 100})
				}

				if(!window.is_mobile){
					resetMarkers(allMarkers)
					map.panTo(this.position)
					this.setOptions({'opacity': 1, 'icon': "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_ALO.svg", 'zIndex': 100})
				}
			})
			
			//map markers to GMap & create array of all marker objects (allMarkers)
			for (i = 0; i < markers.length; i++) {  
				marker = new google.maps.Marker({
					'position': new google.maps.LatLng(markers[i]['lat'], markers[i]['long']),
					'map': map,
					'opacity': .8,
					'icon': pin,
					'category': markers[i]['category'],
					'id': markers[i]['id'],
					'title': markers[i]['title'],
					'zIndex': 1
				});

				marker.addListener("click", function (event) {
					if(event && !window.is_mobile){
						scrollToCard(this.id)
					}

					if(!window.is_mobile){
						resetMarkers(allMarkers)
						map.panTo(this.position)
						this.setOptions({'opacity': 1, 'icon': "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_active.svg", 'zIndex': 100})
						markerALO.setOptions({'opacity': .8, 'icon': "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_ALO_inactive.svg", 'zIndex': 1})
					}
				})

				allMarkers.push(marker)
			}

			//function to filter map marker pins when category dropdown changed
			this.filterPins = function(category){
				clearMarkers();

				for (i = 0; i < allMarkers.length; i++) {  
					for (i = 0; i < allMarkers.length; i++) {
						if(category)
							if(allMarkers[i].category == category)
								allMarkers[i].setOptions({'visible': true, 'opacity': 0.8, 'icon': "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_inactive.svg", 'zIndex': 1})
							else
								allMarkers[i].setOptions({'visible': false})
						else
							allMarkers[i].setOptions({'visible': true, 'opacity': 0.8, 'icon': "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_inactive.svg", 'zIndex': 1})
					}
				}

			}

			//function to determine which card is in view when user scrolls
			function getActiveCard(cards, docViewTop, activeCategory){
				var activeCardId, offset

				if(window.is_mobile){
					offset = $(window).height()/3 + 100
				} else {
					offset = 300
				}

				if(docViewTop > $(window).height()/3){
					cards.some(function (card) {
						if (card.position > (docViewTop + offset)) {
							if(activeCategory){
								if(card.category == activeCategory){
									activeCardId = card.id
									return true
								}
							} else {
								activeCardId = card.id
								return true
							}

						}
					})
				} else {
					activeCardId = 0
				}

				return activeCardId
			}

			//function to scroll to card when user clicks on a marker/pin on GMap
			function scrollToCard(cardID){
				scrollAnimating = true

				if(cardID == 0){
					$([document.documentElement, document.body]).animate({
						scrollTop: 0
					}, {
						duration: 1000,
						complete: function() { 
							scrollAnimating = false 
						}
					});
				} else {
					$([document.documentElement, document.body]).animate({
						scrollTop: localAreaCards.filter('[data-id=' + cardID +']').offset().top-100
					}, {
						duration: 1000,
						complete: function() { 
							scrollAnimating = false 
						}
					});
				}
			}

			//function to dim inactive marker/pins on GMap
			function resetMarkers(markers){
				for (i = 0; i < markers.length; i++) { 
					if(activeCategory){
						if(markers[i].category == activeCategory)
							markers[i].setOptions({'visible': true, 'opacity': .8, 'icon': "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_inactive.svg", 'zIndex': 1})
						else
							markers[i].setOptions({'visible': false})
					} else {
						markers[i].setOptions({'visible': true, 'opacity': .8, 'icon': "/wp-content/themes/alohilani/css/images/ico/local_area_map_pin_inactive.svg", 'zIndex': 1})
					}
				}
			}

			//function to hide all markers on GMap
			function clearMarkers(){
				prevActiveCard = null
				currActiveCard = null

				allMarkers.forEach(function(marker) {
					marker.setOptions({'visible': false})
				});
			}

			this.positionCards = function(){
				cards = []

				$('.local_area_wrapper .local_area_card').each(function(){
					var cardPosition = $(this).offset()
					var cardHeight = $(this).height()
					var cardID = $(this).data('id')
					var cardCategory = $(this).data('category')
					
					card = {"id": cardID, "position": cardPosition.top+cardHeight, "category": cardCategory}
					cards.push(card)
				})
			}

			//window listeners to map cards & update map on scroll
			$(window)
				.on('resize load',function() {
					googleMap.positionCards()
				})
				.on('scroll', function(e) {
					if(!scrollAnimating){
						var docViewTop = $(window).scrollTop()
						var docViewBottom = docViewTop + $(window).height()
						var markersArray = $.makeArray(markers)

						currActiveCard = getActiveCard(cards, docViewTop, activeCategory)

						if(prevActiveCard != currActiveCard){
							prevActiveCard = currActiveCard

							if(currActiveCard == 0){
								google.maps.event.trigger(markerALO, 'click');
							} else {
								markersArray.map(function (marker, i) {

									if (marker.id == currActiveCard) {
										google.maps.event.trigger(allMarkers[i], 'click');
									}
								})
							}
						}
					}
				});
		}

		this.initGoogleMap();

	}

	if($('#google_map').length)
		var googleMap = new GoogleMap('#google_map', markers)

});